import { API_SUPPORT_URL } from "./urls"
import { appendSendVia } from "@/utils/appendSendVia"

const createSupportRequest = (data) => {
  return window.axios
    .post(API_SUPPORT_URL + "request/v1/create", {
      requestBodyDto: {
        clientRoleCode: data.clientRoleCode,
        requestMessage: appendSendVia(data.description),
        clientEmail: data.email,
        requestTypeCode: 20,
      },
    })
    .then(({ data }) => {
      if (data.responseCode !== "OC_OK") {
        throw new Error(data.message)
      }
    })
    .catch((error) => {
      throw error
    })
}

const createFranchisingRequest = (data) => {
  return window.axios
    .post(API_SUPPORT_URL + "franchising/request/v1/create", {
      requestBodyDto: {
        clientRoleCode: data.clientRoleCode,
        clientEmail: data.email,
        requestTypeCode: 20,
        requestName: data.name,
        requestPhone: data.phone,
        requestArea: data.area,
        requestInterest: appendSendVia(data.description),
      },
    })
    .then(({ data }) => {
      if (data.responseCode !== "OC_OK") {
        throw new Error(data.message)
      }
    })
    .catch((error) => {
      throw error
    })
}

const getUserRoles = () => {
  return window.axios
    .get(API_SUPPORT_URL + "user/role/list/v1/get")
    .then(({ data }) => {
      if (data.responseCode === "OC_OK") {
        return data.responseEntity.roles
      }

      throw new Error(data.message)
    })
    .catch((error) => {
      throw error
    })
}

export { createSupportRequest, createFranchisingRequest, getUserRoles }
